export var version = '0.0.1';
//# sourceMappingURL=constants.js.map